import { Component } from '@angular/core';

@Component({
  selector: 'wilson-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss'],
  standalone: false,
})
export class ImpressumComponent {}
